import type { Deal } from '../types/Deal';

export default (deal: Deal): boolean => {
  return deal && deal.offer && deal.offer.currency_iso !== 'AUD' && deal.model !== 'SIM Only';
};
